/**
 * A press on a Start free button, as a GA4 event.
 *
 * It records the click and nothing else: an account made, a site read and a
 * page put live are separate outcomes, recorded by the product where they
 * happen. Consent Mode decides what GA may store; nothing here reads or
 * writes storage of its own. Sent as a beacon, because the click leaves the
 * page.
 */
export function trackSignupCtaClick(placement: string): void {
  if (typeof window === 'undefined') return
  try {
    const payload = {
      cta_placement: placement,
      page_path: window.location.pathname,
      transport_type: 'beacon',
    }
    const w = window as unknown as { gtag?: (...args: unknown[]) => void; dataLayer?: unknown[] }
    if (typeof w.gtag === 'function') {
      w.gtag('event', 'signup_cta_click', payload)
      return
    }
    if (Array.isArray(w.dataLayer)) {
      w.dataLayer.push({ event: 'signup_cta_click', ...payload })
    }
  } catch {
    /* counting a click never gets in the way of the click */
  }
}
